<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 -10 100 100"
>
  <path
    fill="#679a45"
    d="M51.74 61.822h2.925l.536 18.571-5.656.877 2.195-19.448ZM30.52 36.064l2.993.022L33.678 80h-5.966l2.807-43.936ZM69.594 41.174l3.026-.32L72.61 80h-5.917l2.9-38.826Z"
  />
  <path
    fill="#808080"
    d="m63.238 41.98-3.97-11.94 23.737-.047-3.865 12.039-15.902-.052ZM23.868 36.268l-3.97-11.94 23.737-.046-3.865 12.039-15.902-.053ZM45.141 61.982l-3.971-11.94 23.737-.046-3.864 12.038-15.902-.052Z"
    data-player="true"
  />
  <path
    fill="#679a45"
    d="m70.516 50.93-15.052-6.929-4.073 1.9 2.079-6.044 15.77 6.885M68.037 65.388 81.533 50.43l10.762 6.536-9.758-2.138L71.84 65.95l-3.802-.562ZM30.972 49.474 41.124 44.8l4.073 1.899-2.08-6.041-12.658 5.37M32.905 68.662l-6.549-26.19-7.564-.378 4.138 3.804 5.828 26.936 4.147-4.172Z"
  />
</svg>
